import { EnterIcon, UpdateIcon } from '@radix-ui/react-icons';
import { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router';
import '../App.css';
import { Button } from '../components/ui/button';
import {
    Card,
    CardContent,
    CardFooter,
    CardHeader,
    CardTitle,
} from "../components/ui/card";
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { AuthContext } from '../context/AuthContext.js';

function Login() {
    const { login, isLoggedIn, error, clearError } = useContext(AuthContext);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        clearError();
        await login(email, password);
        clearPasswordField();
        setIsLoading(false);
    };

    const clearPasswordField = () => {
        
        setPassword('');
    };

    useEffect(() => {
        clearError(); // Clear error message when the component loads
    }, [clearError]);

    useEffect(() => {
        if (isLoggedIn()) {
            navigate('/upcoming'); // Redirect to home after successful login
        }
    }, [isLoggedIn, navigate]); // Add navigate as a dependency to avoid issues

    return (
        <form onSubmit={handleSubmit} className='flex w-full h-screen items-center justify-center'>
            <Card className='w-3/4 lg:w-7/12 shadow-md'>
                <CardHeader>
                    <CardTitle>Logga in till STAMP</CardTitle>
                </CardHeader>
                <CardContent className='grid gap-4'>
                    <div className='grid gap-2'>
                        <Label htmlFor="email">E-post</Label>
                        <Input
                            id="email"
                            name="email"
                            type="email"
                            autoComplete="email"
                            placeholder="hej@cmdigital.se"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className='grid gap-2'>
                        <Label htmlFor="password">Lösenord</Label>
                        <Input
                            id="password"
                            name="password"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete='current-password'
                        />
                        <Link to='/reset-request' className="ml-auto inline-block text-sm hover:underline">
                            Glömt lösenord?
                        </Link>
                    </div>
                </CardContent>
                <CardFooter>
                    <Button type="submit" className="w-full" disabled={isLoading}>
                        {isLoading ? <UpdateIcon className='loader-spinner' /> : <>Logga in <EnterIcon className='ml-3' /></>}
                    </Button>
                </CardFooter>
                {error && <p className='px-6 pb-6' style={{ color: 'red' }}>{error}</p>}
            </Card>
        </form>
    );
}

export default Login;